import { render, staticRenderFns } from "./EvaluacionComponent.vue?vue&type=template&id=39913ce1&scoped=true"
import script from "./EvaluacionComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionComponent.vue?vue&type=script&lang=js"
import style0 from "./EvaluacionComponent.vue?vue&type=style&index=0&id=39913ce1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39913ce1",
  null
  
)

export default component.exports